import { formField } from '@epages/react-components'
import { useSelector } from 'react-redux'

import { RichTextField as RichTextFieldRaw } from '../formComponents/RichTextField'
import { themeGroupDelimiter } from '../../../utils/themes'
import { useColorOptions } from '../../utils/hooks/colorSettings'
import { useTranslate, withComponents } from '../../utils/translate'
import ColorField from '../formComponents/ColorField'
import FormGroup from '../formComponents/FormGroup'
import RadioButtonField from '../formComponents/RadioButtonField'
import useHelpCenterLink from '../../utils/hooks/useHelpCenterLink'

const RichTextField = formField()(RichTextFieldRaw)

export default function HeaderAnnouncement() {
  const defaultThemeSettings = useSelector<State, ImmutableMap>((state) => state.get('defaultThemeSettings'))
  const themeName = useSelector<State, string>((state) => state.getIn(['shop', 'theme', 'name'], '').replace('.', '_'))
  const [themeGroupName] = themeName.split(themeGroupDelimiter)
  const t = useTranslate('interface', 'components.bottomBar.headerSettings.headerAnnouncement')
  const tThemeSettings = (subKey: string) => t(`:themes:${themeGroupName}.settings.${subKey}`)
  const tColorOptions = (subKey: string) => t(`:components.colorFieldComponent.popover.colorPresets.${subKey}.tooltip`)
  const colorOptions = useColorOptions(tColorOptions, tThemeSettings)

  const isAnnouncementBarActive = useSelector<State, boolean>((state) =>
    state.getIn(['shop', 'userSettings', 'headerAnnouncement', 'active'], false),
  )
  const headerUsps = useSelector<State, ImmutableList>((state) => state.getIn(['shop', 'userSettings', 'headerUsps']))
  const isUspBarActive = headerUsps.some((usp) => usp?.get('active'))
  const showInfoBox = isAnnouncementBarActive && isUspBarActive
  const helpCenterLink = useHelpCenterLink('ANNOUNCEMENT_BAR')

  return (
    <div className="dali-settingslayer-header-announcement">
      <div className="dali-settingslayer-element">
        {withComponents(t)('description', {
          link: (
            <a
              className="ep-form-row-text-external-link"
              href={helpCenterLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('helpCenterLink')}
            </a>
          ),
        })}
      </div>
      {showInfoBox && (
        <div className="dali-settingslayer-element">
          <p className="ep-notification-info">{t('infoBox.description')}</p>
        </div>
      )}
      <FormGroup label={t(`visibilitySection.title`)} name="headerAnnouncement.active">
        <RadioButtonField
          buttons={[
            {
              label: t(`visibilitySection.yesRadioButtonLabel`),
              value: true,
            },
            {
              label: t(`visibilitySection.noRadioButtonLabel`),
              value: false,
            },
          ]}
        />
      </FormGroup>
      <FormGroup label={t(`announcementInputField.label`)} name="headerAnnouncement.announcementHtml">
        <RichTextField toolbarButtons={['bold', 'link|unlink']} restrictToSingleLine maxCharacters={80} />
      </FormGroup>
      <FormGroup
        labelAfterComponent
        name="headerAnnouncement.backgroundColor"
        label={t('colorPicker.label')}
        className="ep-color-field-item"
      >
        <ColorField
          name="headerAnnouncement.backgroundColor"
          className="ep-color-field-box"
          presetColors={colorOptions.toJS()}
          resetValue={defaultThemeSettings.getIn(['headerAnnouncement', 'backgroundColor'])}
          side="left"
          align="end"
        />
      </FormGroup>
    </div>
  )
}
HeaderAnnouncement.defaultValue = {}
